import {Actions} from "../actions/Actions";
import {Preferences} from "@api";
import {IAction} from "../../actions/IshAction";

/**
 * Handle changing global preferences.
 */

const Initial: Preferences = {
  location: {
    currency: {
      shortCurrencySymbol: "$"
    }
  }
}


export const preferencesReducer = (state: Preferences = {...Initial}, action: IAction<Preferences>): Preferences => {
  switch (action.type) {

    case Actions.GET_PREFERENCES_REQUEST_FULFILLED:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};